import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDebounce, usePrevious } from "ahooks";
import { Button } from "../../components";
import Icon from "../../icons";
import Input from "../Input/Input";
const InputSearch = ({ initialValue = "", debounceInMillis = 300, onChange, ...props }) => {
    const [value, setValue] = useState(initialValue);
    const debouncedValue = useDebounce(value, { wait: debounceInMillis });
    const previousDebouncedValue = usePrevious(debouncedValue);
    const handleChange = (event) => setValue(event.target.value);
    const handleClear = () => setValue("");
    useEffect(() => {
        if (debouncedValue !== previousDebouncedValue)
            onChange(debouncedValue);
    }, [debouncedValue, previousDebouncedValue, onChange]);
    return (_jsx(Input, { ...props, startIcon: _jsx(Icon, { name: "search" }), endIcon: value ? _jsx(Button, { "data-testid": "clear-search", variant: "ghost", color: "secondary", icon: _jsx(Icon, { name: "x", className: "text-gray-12" }), onClick: handleClear }) : null, value: value, onChange: handleChange }));
};
export default InputSearch;
